import { render, staticRenderFns } from "./AdminAssignPerms.vue?vue&type=template&id=ab5be508&scoped=true&"
import script from "./AdminAssignPerms.vue?vue&type=script&lang=js&"
export * from "./AdminAssignPerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5be508",
  null
  
)

export default component.exports